import React from 'react';

import references from '../../../css-library/tokens/reference';
import { IconSizes } from '../../../visuals/Icons/type';
import AlertIcon from '../../../visuals/Icons/Alert';

interface IWarningTextProps {
  children: React.ReactNode;
}

export const WarningText: React.FC<IWarningTextProps> = ({ children }) => {
  return (
    <span className="tw-lf-form-input-bottom-message tw-flex tw-items-center tw-gap-2 tw-rounded-lg tw-bg-yellow-200 tw-px-3 tw-py-2 tw-grid-area-[text] group-[.text-input-action]:tw-ml-2">
      <AlertIcon color={references.colors.black[1000]} size={IconSizes.sm} />
      <span className="tw-lf-input-warning-message">{children}</span>
    </span>
  );
};
